<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      title: $t('ETAB.PAGES.EXTRA.@PHOTO_TITLE', { name: title }),
    }"
    :quasar-props="{
      maximized: false,
    }"
  >
    <template #body>
      <img class="full-width" :src="picture" alt="photo candidat" :draggable="false" />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      picture: {
        type: String,
        default: "",
      },
      title: {
        type: String,
        default: "",
      },
    },
    emits: ["update:opened"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
    },
  };
</script>
